import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CS_BASE_URL } from '../utils/ProjectUrls';
import { ParametersForTable } from '../schemas/ParametersForTable';

export const treeSlice = createApi({
    reducerPath: 'tree',
    // 设置API请求的基本URL
    // Set the base URL for API requests
    baseQuery: fetchBaseQuery({ baseUrl: CS_BASE_URL }),
    // 定义API endpoints
    // Define the API endpoints
    endpoints: (builder) => ({
        getParametersByDefs: builder.query<ParametersForTable[], { def: number; subdef: number[] }>(
            {
                query: ({ def, subdef }) => `tree/${def}/${subdef.join(',')}/parameters`,
            }
        ),
    }),
});

export const { useGetParametersByDefsQuery, useLazyGetParametersByDefsQuery } = treeSlice;
